import { atom } from 'jotai/index';
import { atomWithDefault, loadable } from 'jotai/utils';
import { fetchUserPreferences, saveUserPreferences } from '~/service/userPreferencesService';
import { applyDefaultSavedViewForProfile } from '~/service/userPreferencesService';
import { userAtom } from './user';
import log from '../logger';
const baseUserPreferencesAtom = atomWithDefault(() => fetchUserPreferences());
export const userPreferencesModalOpenAtom = atom(false);
export const userPreferencesAtom = atom((get) => get(baseUserPreferencesAtom), async (get, set, update) => {
    const current = await get(baseUserPreferencesAtom);
    const updated = { ...current, ...update };
    const user = await get(userAtom);
    if (updated.brand && updated.division && updated.fieldsOfPlay) {
        await saveUserPreferences({
            brand: updated.brand,
            division: updated.division,
            fieldsOfPlay: updated.fieldsOfPlay
        });
        try {
            const projectId = await applyDefaultSavedViewForProfile(updated.division, updated.brand, updated.fieldsOfPlay);
            if (projectId) {
                log.info('Successfully applied default saved view for profile update', {
                    userEmail: user.email,
                    division: updated.division,
                    brand: updated.brand,
                    fieldsOfPlay: updated.fieldsOfPlay,
                    projectId
                });
            }
        }
        catch (error) {
            log.error('Failed to apply default saved view after profile update', {
                userEmail: user.email,
                division: updated.division,
                brand: updated.brand,
                fieldsOfPlay: updated.fieldsOfPlay,
                error: error instanceof Error ? error.message : 'Unknown error'
            });
        }
    }
    set(baseUserPreferencesAtom, Promise.resolve(updated));
    return updated;
});
export const isProfileCompleteAtom = atom(async (get) => {
    const preferences = await get(userPreferencesAtom);
    return !!(preferences.brand &&
        preferences.division &&
        preferences.fieldsOfPlay);
});
const loadableProfileAtom = loadable(isProfileCompleteAtom);
const loadableUserPreferencesAtom = loadable(userPreferencesAtom);
export const profileCheckStatusAtom = atom((get) => {
    const profileState = get(loadableProfileAtom);
    const preferencesState = get(loadableUserPreferencesAtom);
    let result = {
        isLoading: true,
        isComplete: false,
        hasError: false,
        errorMessage: null
    };
    if (profileState.state === 'hasError' ||
        preferencesState.state === 'hasError') {
        result = {
            isLoading: false,
            isComplete: false,
            hasError: true,
            errorMessage: 'Failed to load user preferences - allowing app usage with warning'
        };
    }
    else if (profileState.state === 'hasData') {
        result = {
            isLoading: false,
            isComplete: profileState.data,
            hasError: false,
            errorMessage: null
        };
    }
    return result;
});
